import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { Typography } from 'wtb-components';
import { ContactMessage } from 'components';

import { useLocaleContext } from 'context';
import { ReactComponent as RejectedAnimation } from 'assets/animations/rejected/rejected.svg';
import { ANALYTICS_EVENTS } from 'constants.js';
import { useSendAnalyticsEvent } from 'hooks';
import styles from '../Finish.module.css';

const Rejected = () => {

  const { translate } = useLocaleContext();

  const sendAnalyticsEvent = useSendAnalyticsEvent();

  useEffect(() => {
    sendAnalyticsEvent(ANALYTICS_EVENTS.REJECTED);
  }, [ sendAnalyticsEvent ]);

  return (
    <div className={styles.rootError}>
      <RejectedAnimation className={styles.animation} data-testid="image-rejected" />

      <Typography className={styles.title} variant="subtitle1" align="center" id="finish-title">
        {translate('finish.rejected.title')}
      </Typography>

      <Typography
        variant="body2"
        align="center"
        className={styles.greyText}
        id="finish-subtitle"
      >
        <Trans
          i18nKey="finish.rejected.subtitle"
          components={[ <Typography variant="body2" align="center" fontWeight="bold" /> ]}
        />
      </Typography>

      <ContactMessage center />
    </div>
  );
};

export default Rejected;
